import React from 'react';
import * as styles from './Feedback.module.scss';
const Feedback = ({
  label,
  children,
  classname
}) => {
  if (!children) {
    return false;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || ''}`
  }, label && /*#__PURE__*/React.createElement("span", {
    className: styles.rootLabel
  }, label), /*#__PURE__*/React.createElement("div", {
    className: styles.rootIcons
  }, children));
};
export default Feedback;